import { MembroUnidade } from 'model/reino/MembroUnidade';
import { ApiAxios } from '../ApiAxios';
import { MembroUnidadeGetAllItemDTO } from 'model/reino/MembroUnidadeGetAllItemDTO';
import { Api } from '../Api';
import { MembroUnidadeDTO } from 'model/reino/MembroUnidadeDTO';


export class ApiMembrosUnidade {
  static async getAll(idReino: number): Promise<MembroUnidadeGetAllItemDTO[]> {
    const response = await ApiAxios.instance.get(`/reinos/${idReino}/membrosUnidades`);
    return response.data;
  }

  static async getAllByReino(idReino: number): Promise<MembroUnidadeDTO[]> {
    const response = await ApiAxios.instance.get(`/reinos/${idReino}/membrosUnidades/getAllByReino`);
    console.log("Responsáveis API: ",response.data);
    return response.data;
  }

  static async getAllByUnidadeId(idUnidade: number): Promise<MembroUnidadeGetAllItemDTO[]> {
    const response = await ApiAxios.instance.get(`/reinos/${Api.REINO_PADRAO}/membrosUnidades/getAllByUnidadeId/${idUnidade}`);
    return response.data;
  }
  
  static async adicionar(membroUnidade: MembroUnidadeDTO): Promise<MembroUnidadeDTO> {
    console.log('MembroUnidade: ' + membroUnidade);
    const response = await ApiAxios.instance.post(`/reinos/${Api.REINO_PADRAO}/membrosUnidades`, membroUnidade);
    return response.data;
  };

  static atualizar = async (id: number, data: any) => {
    console.log(`Atualizar: ID: ${id}, Data: ${data}`);
    const response = await ApiAxios.instance.put(`/reinos/${Api.REINO_PADRAO}/membrosUnidades/${id}`, data);
    return response.data;
  };
}
